import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ReactElement, ReactNode } from 'react';

import { ReactComponent as CheckCircleOutlineIcon } from '~/ui/assets/images/check_circle_outline.svg';
import smallAvatarIcon from '~/ui/assets/images/smallAvatar.svg';
import PrivateImage from '~/ui/components/common/PrivateImage';
import DispatchedTypography from '~/ui/pages/Network/components/DispatchedTypography';

import styles from './AllocationClientRow.module.scss';

interface IAllocationClientRowData {
  clientId: number;
  photo?: string;
  name: string;
  isResolved: boolean;
  isCrisis: boolean;
}

interface IProps {
  client: IAllocationClientRowData;
  memoField: ReactNode;
  actions?: ReactNode;
  alertMessage?: string | null;
  noteMessage?: string | null;
  teamsField?: ReactNode;
}

const AllocationClientRow = ({
  client,
  memoField,
  actions,
  alertMessage,
  noteMessage,
  teamsField,
}: IProps): ReactElement => {
  const { photo, name, isResolved, isCrisis } = client;

  return (
    <Grid
      container
      className={styles.clientDetailItem}
      sx={{
        alignItems: 'center',
      }}
    >
      <Grid className={styles.selectedClient} size={teamsField ? 4 : 6}>
        <PrivateImage
          disabled={isResolved}
          className={styles.image}
          src={photo || smallAvatarIcon}
          height={40}
          alt="avatar"
          additionalIcon={
            isResolved ? (
              <div className={styles.additionalIcon}>
                <CheckCircleOutlineIcon width={16} height={16} />
              </div>
            ) : undefined
          }
        />
        <Typography>{name}</Typography>
        {isCrisis && <DispatchedTypography />}
      </Grid>
      {teamsField && (
        <Grid className={styles.teamField} size={4}>
          {teamsField}
        </Grid>
      )}
      <Grid className={styles.memoContainer} size={teamsField ? 4 : 6}>
        {memoField}
        {actions}
      </Grid>
      {alertMessage && (
        <Grid
          className={styles.validationErrors}
          size={{
            sm: 12,
          }}
        >
          {alertMessage}
        </Grid>
      )}
      {noteMessage && (
        <Grid
          className={styles.validationErrors}
          size={{
            sm: 12,
          }}
        >
          {noteMessage}
        </Grid>
      )}
    </Grid>
  );
};

export default AllocationClientRow;
